import CollectGraphicsBlocks from "./blocks";
import CollectGraphicsGrids from "./grids";
import CollectGraphicsHelpers from "./helpers";
import CollectGraphicsHooks from "./hooks";
import CollectGraphicsModals from "./modals";
import CollectGraphicsForms from "./forms";
import CollectGraphicsFields from "./fields";

const CollectGraphics = {
    Blocks  : CollectGraphicsBlocks,
    Grids   : CollectGraphicsGrids,
    Helpers : CollectGraphicsHelpers,
    Hooks   : CollectGraphicsHooks,
    Modals  : CollectGraphicsModals,
    Forms   : CollectGraphicsForms,
    Fields  : CollectGraphicsFields
}

export default CollectGraphics;